import { render } from "./FavouriteCard.vue?vue&type=template&id=6ed5fd40&scoped=true"
import script from "./FavouriteCard.vue?vue&type=script&lang=js"
export * from "./FavouriteCard.vue?vue&type=script&lang=js"

import "./FavouriteCard.vue?vue&type=style&index=0&id=6ed5fd40&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed5fd40"]])

export default __exports__